import { AutoCaptureHintsEnum, } from '../helper/types.js';
const pageElementOpts = {
    showAutocaptureCancelButton: true,
};
const customMessages = {
    DL_FRONT: {
        firstMessage: 'Please - Center document on a dark background',
        fourCornerMessage: 'Center document on a dark background',
    },
    PASSPORT: {
        firstMessage: 'Center photo page on a dark background',
        fourCornerMessage: 'Center photo page on a dark background',
    },
    CHECK_FRONT: {
        firstMessage: 'Center Check Front on a dark background',
        fourCornerMessage: 'Scanning for Check Front',
    },
    CHECK_BACK: {
        firstMessage: 'Center Check Back on a dark background',
        fourCornerMessage: 'Scanning for Check Back',
    },
    SELFIE: {
        firstMessage: 'Place face in oval',
        fourCornerMessage: 'Face not found',
    },
};
const firstMessageDuration = 1500;
const autoCaptureAttemptTimer = null;
const autoCaptureOptions = {
    qualityPercent: 100,
    hintFrequencyMS: 1000,
    hintAriaLive: 0,
    faceDetectionLevel: 1,
    hintMessageSize: 1,
    disableSmileDetection: true,
    disablePerpendicularCapture: true,
    redactMRZOptionalData: true,
    glareLevel: 2,
    blurLevel: 2,
};
const componentPreloadConfig = {
    preloadComponents: ['DOCUMENTS'],
    redactMRZOptionalData: true,
};
export const pageStateObject = {
    pageElementOpts,
    firstMessageDuration,
    autoCaptureAttemptTimer,
    autoCaptureOptions,
    autoCaptureHints: AutoCaptureHintsEnum,
    componentPreloadConfig,
    customMessages,
};
//# sourceMappingURL=mitekConfiguration.js.map